/* lb-desktop-mega-hover.js — v3 (fix first-item jump) */
(function () {
  const MQ = window.matchMedia("(min-width: 1025px)");
  let cleanups = [];

  const DURATION_MS = 360; // قريب من 0.34s

  function getMenus() {
    return Array.from(document.querySelectorAll("header-menu details.mega-menu"));
  }

  function getSummary(details) {
    return details.querySelector("summary.header__menu-item");
  }

  function clearTimers(details) {
    if (details._lbCloseTimer) {
      clearTimeout(details._lbCloseTimer);
      details._lbCloseTimer = null;
    }
    if (details._lbDoneTimer) {
      clearTimeout(details._lbDoneTimer);
      details._lbDoneTimer = null;
    }
  }

  function clearState(details) {
    details.classList.remove("lb-mega-opening", "lb-mega-closing");
  }

  function setExpanded(details, expanded) {
    const summary = getSummary(details);
    if (summary) summary.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function closeAll(except = null) {
    getMenus().forEach((d) => {
      if (except && d === except) return;
      closeAnimated(d);
    });
  }

  function closeAnimated(details) {
    if (!details.hasAttribute("open")) return;

    clearTimers(details);

    // لو كان بيفتح، نوقف الفتح ونبدأ قفل
    clearState(details);
    details.classList.add("lb-mega-closing");
    setExpanded(details, false);

    const done = () => {
      details.removeAttribute("open");
      clearState(details);
      details._lbDoneTimer = null;
    };

    // fallback قوي
    details._lbDoneTimer = setTimeout(done, DURATION_MS + 80);
  }

  function openAnimated(details) {
    clearTimers(details);

    // اقفل كل الباقي بانيميشن
    closeAll(details);

    // ترتيب مهم جدًا لتفادي "النطّة" خصوصًا في أول عنصر:
    // 1) opening class
    // 2) set open
    // 3) reflow
    // 4) next frame remove opening => transition
    clearState(details);
    details.classList.add("lb-mega-opening");
    details.setAttribute("open", "");
    setExpanded(details, true);

    const content = details.querySelector(".mega-menu__content");
    // force reflow on content (الأفضل)
    if (content) void content.offsetHeight;
    else void details.offsetHeight;

    requestAnimationFrame(() => {
      // لو المستخدم خرج بسرعة قبل ما نبدأ
      if (!details.matches(":hover")) return;
      details.classList.remove("lb-mega-opening");
    });
  }

  function enable() {
    const all = getMenus();
    if (!all.length) return;

    // reset state (يمنع أي state غريب على أول لينك)
    all.forEach((d) => {
      clearTimers(d);
      clearState(d);
      d.removeAttribute("open");
      setExpanded(d, false);
    });

    all.forEach((details) => {
      const summary = getSummary(details);
      if (!summary) return;

      const onSummaryClick = (e) => e.preventDefault();

      const onEnter = () => openAnimated(details);

      const onLeave = (e) => {
        if (details.contains(e.relatedTarget)) return;
        clearTimers(details);
        details._lbCloseTimer = setTimeout(() => closeAnimated(details), 120);
      };

      const onFocusOut = (e) => {
        if (!details.contains(e.relatedTarget)) onLeave(e);
      };

      summary.addEventListener("click", onSummaryClick);
      details.addEventListener("mouseenter", onEnter);
      details.addEventListener("mouseleave", onLeave);
      details.addEventListener("focusout", onFocusOut);

      cleanups.push(() => {
        clearTimers(details);
        summary.removeEventListener("click", onSummaryClick);
        details.removeEventListener("mouseenter", onEnter);
        details.removeEventListener("mouseleave", onLeave);
        details.removeEventListener("focusout", onFocusOut);
        clearState(details);
        details.removeAttribute("open");
        setExpanded(details, false);
      });
    });

    const onOutside = (e) => {
      const inside = e.target.closest("header-menu details.mega-menu");
      if (!inside) getMenus().forEach(closeAnimated);
    };
    document.addEventListener("pointerdown", onOutside);
    cleanups.push(() => document.removeEventListener("pointerdown", onOutside));

    const onEsc = (e) => {
      if (e.key === "Escape") getMenus().forEach(closeAnimated);
    };
    document.addEventListener("keydown", onEsc);
    cleanups.push(() => document.removeEventListener("keydown", onEsc));
  }

  function disable() {
    cleanups.forEach((fn) => fn());
    cleanups = [];
    getMenus().forEach((d) => {
      clearTimers(d);
      clearState(d);
      d.removeAttribute("open");
      setExpanded(d, false);
    });
  }

  function sync() {
    if (MQ.matches) enable();
    else disable();
  }

  MQ.addEventListener?.("change", sync);
  sync();
})();
